import{m as e}from"./chunk-HBP5N4FR.js";e();var u=(r,t)=>r?r.address===t||r.activeGuardianAddress===t:!0;export{u as a};
//# sourceMappingURL=chunk-LWYHJW4B.js.map
